import { Injectable } from "@angular/core";
import { BaseService } from "./base.service";
import { Observable } from "rxjs";
import { EstruturaRetornoDadosOutputDto } from "../domain/DTOs/output/estrutura-retorno-dados.output.dto";
import { PaginaJornalOutputDto } from "../domain/DTOs/output/jornal/pagina-jornal.output.dto";

@Injectable()
export class AutenticidadeService{
  
  constructor(private readonly baseService: BaseService) {}

  public ObterPaginaJornalPorAutenticidade(
      inputDto: string
    ): Observable<EstruturaRetornoDadosOutputDto<PaginaJornalOutputDto>> {
      return this.baseService.get(`Autenticidade/ObterPaginaJornalPorAutenticidade?autenticidade=${inputDto}`);
    }
}